/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_FailedInputs */

const vi_carrier_return_decision_failed = /** @type {(inputs: Carrier_Return_Decision_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gửi được phản hồi cho Viettel Post`)
};

/**

* @param {Carrier_Return_Decision_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_failed = /** @type {((inputs?: Carrier_Return_Decision_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_failed(inputs)
});